import { InjectionToken } from '@angular/core';

import { DataExtension, SetupExtension } from 'shared-utils/file-system';

import type { FileItem } from './models';

export const FILE_BROWSER_OPEN_LOCAL_FILE_ACTION: InjectionToken<(file: FileItem) => void> =
  new InjectionToken<(file: FileItem) => void>('FILE_BROWSER_OPEN_LOCAL_FILE_ACTION');

export const FILE_BROWSER_OPEN_DRIVE_FILE_ACTION: InjectionToken<(file: FileItem) => void> =
  new InjectionToken<(file: FileItem) => void>('FILE_BROWSER_OPEN_DRIVE_FILE_ACTION');

export const FILE_BROWSER_ACCEPTED_EXTENSIONS: InjectionToken<(SetupExtension | DataExtension)[]> =
  new InjectionToken<(SetupExtension | DataExtension)[]>('FILE_BROWSER_ACCEPTED_EXTENSIONS');

export const FILE_BROWSER_ENV_CONFIG: InjectionToken<{ isLocal: boolean, isCloudConnected: boolean }> =
  new InjectionToken<{ isLocal: boolean, isCloudConnected: boolean }>('FILE_BROWSER_ENV_CONFIG');
